import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { percent: Number }

  connect() {
    const target = Math.max(0, Math.min(100, this.percentValue))
    const indicator = this.element.querySelector('[data-gauge-indicator]')
    const fill = this.element.querySelector('[data-gauge-fill]')
    if (!indicator) return

    const setPos = (pos) => {
      const v = Math.max(0, Math.min(100, pos))
      indicator.style.left = `calc(${v}% - 1px)`
      if (fill) fill.style.width = `${v}%`
    }

    // 키프레임 보간 (smoothstep 이징)
    const smoothstep = (t) => t * t * (3 - 2 * t)
    const interp = (kf, t) => {
      for (let i = 0; i < kf.length - 1; i++) {
        const [t0, v0] = kf[i], [t1, v1] = kf[i + 1]
        if (t <= t1) return v0 + (v1 - v0) * smoothstep((t - t0) / (t1 - t0))
      }
      return kf[kf.length - 1][1]
    }

    // ── Phase 1: 0% → 100% 전체 스캔 (800ms) ───────────────────────────
    const sweepDur = 800
    let p1s = null
    const phase1 = (ts) => {
      if (!p1s) p1s = ts
      const t = Math.min((ts - p1s) / sweepDur, 1)
      const e = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2
      setPos(e * 100)
      t < 1 ? requestAnimationFrame(phase1) : requestAnimationFrame(phase2)
    }

    // ── Phase 2: 전체 왕복 2회 → target 수렴 정착 (3000ms) ──────────────
    //
    // 모든 등급 공통 패턴:
    //   100% → 0% → 100% → 0% → (target으로 수렴)
    //
    //   t=0.00  100%   (Phase1 종점)
    //   t=0.22    0%   (1차 풀스윙: 베이직 끝)
    //   t=0.44  100%   (2차 풀스윙: 다이아 끝)
    //   t=0.62    0%   (3차 풀스윙: 베이직 끝)
    //   이후 target 쪽으로 수렴
    //
    // diamond(100%): 0 → 100 → 0 → 100 → 정착 100  ✓
    // premium( 67%): 0 → 100 → 0 → 83 → 54 → 69 → 67  ✓
    // basic  ( 17%): 0 → 100 → 0 → 59 → 14 → 20 → 17  ✓

    const kf = [
      [0.00, 100],
      [0.22,   0],                              // 1차 좌끝
      [0.44, 100],                              // 2차 우끝
      [0.62,   0],                              // 3차 좌끝
      [0.76, target + (100 - target) * 0.55],  // 수렴 시작 (target 방향)
      [0.87, target - target * 0.22],           // 소폭 역방향
      [0.94, target + (100 - target) * 0.07],  // 미세 오버슈트
      [1.00, target],                           // 정착
    ]

    const settleDur = 3000
    let p2s = null
    const phase2 = (ts) => {
      if (!p2s) p2s = ts
      const t = Math.min((ts - p2s) / settleDur, 1)
      if (t >= 1) { setPos(target); return }
      setPos(interp(kf, t))
      requestAnimationFrame(phase2)
    }

    setPos(0)
    setTimeout(() => requestAnimationFrame(phase1), 400)
  }
}
